import React from 'react';
import { TouchableHighlight, TouchableOpacity, View } from 'react-native';
import ImageIcon from '../../../components/shared/Icon/ImageIcon.component';
import { modalService } from '../../../services/modal.service';
import httpService from '../../../services/http.service';
import AlertModal from '../../../modals/AlertModal/AlertModal.component';
import I18n from '../../../components/shared/i18n/I18n.component';
import ModalConfirmActions from '../../../modals/ModalConfirmActions/ModalConfirmActions.component';
import LocationSettingsModal from './LocationSettingsModal/LocationSettingsModal';
import ActionButtonContainer from '../../../components/shared/Buttons/ActionButton.container';
import colors from '../../../config/colors';

export interface LocationData {
	id: number;
	location: {
		id: number;
		lat: number;
		lon: number;
		locationName: string;
		placeId: string;
	};
	name: string;
	status: boolean;
	radius: number;
	projects: string[];
	allDepartments: true;
	departments: string[];
	allUsers: boolean;
	users: {
		excludeSelected: boolean;
		userIds: number[];
	};
}

export const EditDeleteButton = ({
	iconName,
	height,
	width,
	onPress,
	disabled,
}: {
	iconName: string;
	height: number;
	width: number;
	onPress(): void;
	disabled: boolean;
}) => {
	return (
		<TouchableHighlight
			underlayColor='transparent'
			disabled={disabled}
			onPress={onPress}
			style={{
				opacity: disabled ? 0.5 : 1,
			}}
		>
			<ImageIcon name={iconName} height={height} width={width} />
		</TouchableHighlight>
	);
};

export const onDelete = async (id, refresh) => {
	await modalService.openModal(
		null,
		{
			submitBtnText: 'general.delete',
			cancelBtnText: 'general.cancel',
			iconName: 'attention',
			hideCloseBtn: true,
		},
		(props: any) => (
			<View style={{width: 450, padding: 32, backgroundColor: 'white', borderRadius: 8}}>
					 <View style={{ flexDirection: 'row-reverse', alignItems: 'center', justifyContent: 'space-between', marginBottom: 24 }}>
						<I18n color='primaryDarkBlue' weight='bold' size={17} >
							locationSettings.deleteTitleModal
						</I18n>
						<TouchableOpacity onPress={() => props.onNext()} style={{ height: 18, width: 18 }}>
							<ImageIcon name={'closePopup'} height={18} width={18} />
						</TouchableOpacity>
					 </View>
					<I18n color='primaryDarkBlue' size={15} style={{ marginBottom: 40 }} >
						locationSettings.deleteModal
					</I18n>
					<View style={{ flexDirection: 'row'}}>
						<ActionButtonContainer
							overrideStyle={{width: 100, height: 40, backgroundColor: colors.titlePrimary, borderRadius: 8, paddingHorizontal: 12, paddingVertical: 11, marginRight: 16 }}
							hoverStyle={{backgroundColor: colors.primaryDark}}
							onPress={() => props.onNext(startDelete(id, refresh))}
						>
							<I18n size={16} weight='normal' color='white'>{props.submitBtnText}</I18n>
						</ActionButtonContainer>
						<ActionButtonContainer
							overrideStyle={{width: 100, height: 40, borderWidth: 1, borderColor: colors.titlePrimary, paddingHorizontal: 12, paddingVertical: 11 }}
							onPress={() => props.onNext()}
						>
							<I18n size={16} weight='normal' color='primary'>{props.cancelBtnText}</I18n>
						</ActionButtonContainer>
					</View>
			</View>
		),
	);
};

const startDelete = async (id, refresh) => {
	try {
		const res = await httpService.api<any>({
			type: 'deleteLocation',
			params: { locationId: id },
		});
		refresh();
	} catch (e) {}
};

export const onEdit = async (
	id,
	projectsFilterList,
	departmentsFilterList,
	refresh,
	businessUnitId: number,
) => {
	try {
		const res: LocationData = await httpService.api<any>({
			type: 'getExistingLocation',
			params: { locationId: id },
		});

		const users = await httpService.api<any>({
			type: 'getUsersByDepartments',
			query: { pageName: 'locationSettings', unitId: businessUnitId },
			data: {
				search: '',
				f: { dep: [], internal: ['true'] },
			},
		});

		await modalService.openModal(null, {hideCloseBtn: true}, (props: any) => (
			<LocationSettingsModal
				{...props}
				users={users}
				locationId={id}
				businessUnitId={businessUnitId}
				locationData={res}
				projectsFilterList={projectsFilterList}
				departmentsFilterList={departmentsFilterList}
				refresh={refresh}
				onClose={() => props.onNext({ type: 'close' })}
			/>
		));
	} catch (e) {}
};
